import * as React from 'react';
import { useEffect } from 'react';
import { observer } from 'mobx-react';

import { ViewLarge, ViewSmall, Viewport } from 'bernie-view';
import { UitkText } from 'uitk-react-text';

import { FlightsTripType } from '__generated__/api';
import { FilterPills } from 'components/search/sort-filter';
import { Banners, ShowMoreButton } from 'components/shared';
import { ErrorListings } from 'components/search/error-messages';
import { Listings, ListingsLoading } from 'components/search/listings';
import { MesoDisplayAdsGroup } from 'components/meso';
import { ListingsHeaderBar } from './listings/listings-header-bar';
import { useStores } from 'utility/hooks';
import { FlexibleSearch, FlexibleSearchGrid } from './flexible-search';
import { OpinionLabButton } from 'components/shared/opinion-lab';
import { StepIndicator } from 'components/shared';
import { Notification } from 'components/shared/notification';
import { PageTitle } from './search-heading';

export const SearchResults = observer(() => {
  const {
    bannersStore,
    errorStore,
    flexibleSearchResultsStore,
    listingsStore,
    pageTitleStore,
    opinionLabStore,
    sortFilterStore,
    searchCriteriaStore,
    stepIndicatorStore
  } = useStores();
  const { subTitle } = pageTitleStore;
  const { loading, pinnedListingUnavailableMessage } = listingsStore;
  const { journeyContinuationId } = stepIndicatorStore;

  useEffect(() => {
    if (loading) {
      window.scrollTo(0, 0);
    }
  }, [loading]);

  return (
    <>
      {journeyContinuationId ? (
        <StepIndicator showLoadingStateOnLargeView={false} padding={{ blockend: 'six' }} />
      ) : (
        <PageTitle />
      )}
      <main data-test-id="search-results">
        {listingsStore.accessibilityMessage && (
          <h2 className="is-visually-hidden">{listingsStore.accessibilityMessage}</h2>
        )}
        {sortFilterStore && sortFilterStore.appliedFiltersSummary && (
          <Viewport>
            <ViewLarge>
              <FilterPills appliedFiltersSummary={sortFilterStore.appliedFiltersSummary} />
            </ViewLarge>
          </Viewport>
        )}
        {flexibleSearchResultsStore &&
          !flexibleSearchResultsStore.loading &&
          !errorStore.shouldRenderFailedRequestError && (
            <>
              {flexibleSearchResultsStore.tripType === FlightsTripType.ONE_WAY && <FlexibleSearch />}
              {flexibleSearchResultsStore.tripType === FlightsTripType.ROUND_TRIP &&
                searchCriteriaStore.fetchFlexResults && <FlexibleSearchGrid />}
            </>
          )}
        {!errorStore.shouldRenderFailedRequestError && (
          <Viewport>
            <ViewLarge>
              <ListingsHeaderBar />
            </ViewLarge>
          </Viewport>
        )}
        {!loading && (
          <>
            {subTitle && (
              <Viewport>
                <ViewSmall>
                  <div data-test-id="price-subtitle" className="all-b-padding-three">
                    <UitkText size={200} align="center">
                      {subTitle.shortMessage}
                    </UitkText>
                  </div>
                </ViewSmall>
                <ViewLarge />
              </Viewport>
            )}
            {bannersStore && bannersStore.banners && (
              <Banners classes="all-b-margin-three all-t-margin-one s-t-margin-three m-t-margin-three" />
            )}
          </>
        )}
        {loading ? <ListingsLoading /> : listingsStore.offersFound ? <Listings /> : <ErrorListings />}
        {pinnedListingUnavailableMessage && <Notification message={pinnedListingUnavailableMessage} />}
        {!loading && listingsStore && listingsStore.listingsAction && <ShowMoreButton />}
        <section className="uitk-cell uitk-type-center all-y-margin-three" data-test-id="meso-display-ads-group">
          <MesoDisplayAdsGroup type={MesoDisplayAdsGroup.adType.MESO_CM_ADS} />
        </section>
        {!loading && opinionLabStore && opinionLabStore.label && <OpinionLabButton classes="all-t-margin-six" />}
      </main>
    </>
  );
});
